import getCookie from './getCookie'
import isBrowser from './isBrowser'

const TELEMETRY_COOKIE_NAME = 'qsf_telemetry'

export default function shouldDisableTelemetry() {
  if (!isBrowser) return true
  return getCookie(TELEMETRY_COOKIE_NAME) === 'off'
}
